export const GIFT_PURCHASE_IMPACT_ID = 28329;
export const SALE_EVENT_PURCHASE_IMPACT_ID = 28645;
